import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';

interface MassExportConfirmationDialogModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  scopeLabel: string;
}

export const MassExportConfirmationDialogModal: React.FC<
  MassExportConfirmationDialogModalProps
> = ({ open, onConfirm, onCancel, scopeLabel }) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Alles exportieren bestätigen</DialogTitle>
          <DialogDescription>
            <>
              <p className="mt-4">
                Bist du sicher, dass du <b>{scopeLabel}</b> möchtest?
              </p>
              <p className="mt-4">
                Dies kann je nach Datenmenge länger dauern.
              </p>
              <p className="mb-4">
                Die <b>maximale</b> Menge an exportierbaren Zeilen beträgt{' '}
                <b>100.000</b>
              </p>
            </>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex justify-end gap-3">
          <Button variant="outline" onClick={onCancel}>
            Abbrechen
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Ja, Export starten
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
